import { render, staticRenderFns } from "./Study_businessPlus.vue?vue&type=template&id=13128cd1"
import script from "./Study_businessPlus.vue?vue&type=script&lang=js"
export * from "./Study_businessPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports